// src/PartnerDashboard.js
import React from 'react';
import CaixaDeEntrada from './CaixaDeEntrada';
import DashboardLayout from './DashboardLayout';
import { Typography } from '@mui/material';
import HomeIcon from '@mui/icons-material/Home';
import { auth } from './firebase';

const partnerMenuItems = [
    { text: 'Início', path: '/portal', icon: <HomeIcon /> },
];

function PartnerDashboard({ userProfile, onFirstAccessComplete }) {
    const user = auth.currentUser;

    return (
        <DashboardLayout
            menuItems={partnerMenuItems}
            pageTitle="Portal do Parceiro"
            userProfile={userProfile}
            onFirstAccessComplete={onFirstAccessComplete}
        >
            <Typography variant="h5" gutterBottom>Bem-vindo ao seu portal!</Typography>
            <Typography variant="body1" sx={{ mb: 2 }}>Logado como: {user?.email}</Typography>
            <CaixaDeEntrada user={user} />
        </DashboardLayout>
    );
}

export default PartnerDashboard;
